if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      console.log("cart", this.cart)
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const _this = this;
      // Handling the add to cart with photo uploader if the page support photo uploading
      if (document.querySelector('[ng-app="wbskPuAPP"].ng-scope:not(.ng-hide)')) return;
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if( document.querySelector("body.template-product-greeting-card")){
        _this.customPrintID = popupOverlay?.generateIntId();
      }
      var custom_images = document.querySelectorAll('.custom-image'); // Replace with the class name of your divs

      _this.properties = [];
      
      custom_images?.forEach(function(images , index) {
        var name = images.getAttribute('data-print-name');
        var value = images.getAttribute('data-print-id');
        let i = index
        _this.properties.push({
          name: name,
          value: value,
          imageId:i
        });
      });

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
          const end = window.Shopify.routes.root;
          
        function cleanUrl(url) {
          const endPattern = `${end}`;
        
          if (url.includes(endPattern)) {
            return url.replace(end, '/');
          }
        
          return url;
        }
          
          const currentUrl = window.location.pathname;
          const cleanedUrl = cleanUrl(currentUrl);
               
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url',cleanedUrl)
        _this.properties.forEach(function(property) {
        // formData.append('properties[custom_image_id_' + property.imageId +']', property.value);
          formData.append('properties[custom_print_id]', property.value);
      });
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
console.log(config);
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          _this.sendCustomData();
        });
    
        setTimeout(function() {
          $.getJSON('/cart.js', function(cart) { 
            var result = cart.item_count;
            console.log(result);
            if (result == 1) {
              $('.active_bar').css('width', '0px');
              $('.step1_sc').addClass('active_bar2');
              $('.step2_sc').removeClass('active_bar2');
              $('.step3_sc').removeClass('active_bar2');
              $('.step4_sc').removeClass('active_bar2');
            } else if (result == 2) {
              $('.active_bar').css('width', '33%');
              $('.step1_sc').addClass('active_bar2');
              $('.step2_sc').addClass('active_bar2');
              $('.step3_sc').removeClass('active_bar2');
              $('.step4_sc').removeClass('active_bar2');
            } else if (result == 3) {
              $('.active_bar').css('width', '66%');
              $('.step1_sc').addClass('active_bar2');
              $('.step2_sc').addClass('active_bar2');
              $('.step3_sc').addClass('active_bar2');
              $('.step4_sc').removeClass('active_bar2');
            } else if (result > 3) {
              $('.active_bar').css('width', '98%');
              $('.step1_sc').addClass('active_bar2');
              $('.step2_sc').addClass('active_bar2');
              $('.step3_sc').addClass('active_bar2');
              $('.step4_sc').addClass('active_bar2');
            } else {
                // Handle cases where result is less than 1
                // You may want to set a default width or handle it differently
                $('.active_bar').css('width', '0%');
            }		
          });
        },1000);
      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

     // custom data, when images are uploaded
    sendCustomData() {
      const production = true;
      const API = production? "https://addisionrosebk.marmeto.com": "https://29684b16c152.ngrok.io";
      const CLOUDINARY = "https://addisionrosebk.marmeto.com/api/image/uploadImageToAws";
      const fetchHeaders = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      let data = [];
      if( document.querySelector("body.template-product-greeting-card")){
        let dataToServer = greetingHeader.dataTosendToServer != undefined? JSON.parse(greetingHeader.dataTosendToServer): false;
      } else {
        let dataToServer = false; 
      }
      // let dataToServer = greetingHeader.dataTosendToServer != undefined? JSON.parse(greetingHeader.dataTosendToServer): false;
      // const custom_id = this.properties[0].value;
      const custom_id = this.customPrintID;
      data.push({
        id: custom_id,
        date: new Date(),
        data: dataToServer,
      })

      if (dataToServer) {
        fetch(`${API}/api/image/custom_data`, {
          method: 'POST',
          body:JSON.stringify({data}),
          headers:fetchHeaders
        }).then((response) => {
            console.log(response);
        });
      }
    }
    
  });
}
